import styled from 'styled-components';
import { NoticeType, NoticeVariant } from './Notice';
import { defaultTheme } from '../../styling/theme';

const getNoticeColour = (variant: NoticeVariant) => {
  switch (variant) {
    case 'warn':
      return defaultTheme.COLOUR.WARNING;
    case 'alert':
      return defaultTheme.COLOUR.ALERT_DARK;
    case 'success':
      return defaultTheme.COLOUR.SUCCESS_DARKER;
    case 'info':
      return defaultTheme.COLOUR.SECONDARY;
    default:
      return defaultTheme.COLOUR.WARNING;
  }
};

export const NoticeContainer = styled.div<{
  variant: NoticeVariant;
  type: NoticeType;
  isMobile?: boolean;
  padding?: string;
}>`
  display: flex;
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
  padding: ${props => (props.padding ? props.padding : '0.5rem')};
  border: ${props =>
    props.type === 'borderless'
      ? 'none'
      : `1px solid ${getNoticeColour(props.variant)}`};
  border-radius: ${defaultTheme.EFFECTS.RADIUS_STANDARD};
  align-items: center;
  position: relative;
  overflow: hidden;
  color: ${props =>
    props.type === 'borderless' ? getNoticeColour(props.variant) : 'inherit'};
  ${props => props.type === 'darkmode' && 'color: white;'}
`;

export const NoticeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MobileButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-self: flex-end;
  justify-content: flex-end;
  width: 100%;
  & > * {
    margin-left: 0.5rem;
    margin-bottom: -0.5rem;
  }
`;

export const DesktopButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  & > * {
    margin-left: 0.5rem;
    font-size: 1.25rem;
  }
`;

export const NoticeIconWrapper = styled.div<{ variant: NoticeVariant }>`
  color: ${props => getNoticeColour(props.variant)};
`;

export const NoticeMessageWrapper = styled.div<{
  isMobile?: boolean;
  expanded?: boolean;
}>`
  line-height: 1.5;
  max-height: ${props => (props.expanded || !props.isMobile ? 'auto' : '3rem')};
  margin-left: 1rem;
  overflow: hidden;
`;

export const NoticeTextContainer = styled.div<{ variant: NoticeVariant }>`
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  align-items: center;
  width: 100%;
  color: ${props => getNoticeColour(props.variant)};
`;

export const NoticeTextWrapper = styled.div``;
